const initialLicenseTax = [
    { value: 0, min: 0, max: 0 },
    { value: 1620, min: 1, max: 500 },
    { value: 2160, min: 501, max: 600 },
    { value: 4320, min: 601, max: 1200 },
    { value: 7120, min: 1201, max: 1800 },
    { value: 11230, min: 1801, max: 2400 },
    { value: 15210, min: 2401, max: 3000 },
    { value: 28220, min: 3001, max: 4200 },
    { value: 46170, min: 4201, max: 5400 },
    { value: 69690, min: 5401, max: 6600 },
    { value: 117000, min: 6601, max: 7800 },
    { value: 151200, min: 7801, max: 10000 },
];

export default initialLicenseTax;
